window.gifts = [];

window.showInfo = $('.roominfo').data('info');
window.isQuiz = false;
if (showInfo.interaction_plugins) {
    for (var i = 0; i < showInfo.interaction_plugins; i++) {
        if (showInfo[i] == 'quiz') {
            isQuiz = true;
            break;
        }
    }
}

window.roomInfo = null;

window.liveinfo = null;

window.showid = null;

window.indexPlay = 0;
window.init = false;

window.account = null;


window.client = null;

window.streamStartedInfo = null;


gethotest(8);

window.getgifts = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/gifts',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    gifts = result;

                    for (var i = 0; i < gifts.length; i++) {
                        var gift = gifts[i];
                        var html =
                            '<div class="giftinfo" data-info=' + JSON.stringify(gift) + ' data-index="' + i + '">' +
                            '<img src="' + gift.icon_url + '?w=40&h=40&s=4" />' +
                            '<div class="gift-hover"></div>' +
                            '</div>';
                        $('.giftlist-show-scroll').append(html);
                    }

                    var width = gifts.length * (60 + 15 + 15);
                    $('.giftlist-show-scroll').css('width', width + 'px');
                    clickItem(indexPlay);
                } else {
                    alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

getgifts();

window.getgiftinfo = function (id) {
    for (var i = 0; i < gifts.length; i++) {
        var gift = gifts[i];
        if (gift.id == id) {
            return gift;
        }
    }

    return null;
};

window.clickItem = function (index) {
    if ($('.giftinfo').length > index) {
        $('.giftinfo').eq(index).click();
    }
};

window.move =
    function () {
        if ($('.giftinfo').length > 8) {
            var width = $('.giftinfo').length * (60 + 10 + 10);
            var move = (width - 858) * (60 + 10 + 10) / (width - (858 * 858 / 858)) * (indexPlay - 4);
            $('.giftlist-show').animate({
                scrollLeft: move
            }, 200);
        }
    };

$('.giftlist-leftbtn').click(function () {
    var index = indexPlay;
    index--;
    if (index < 0) {
        index = 0;
    }

    clickItem(index);
});

$('.giftlist-rightbtn').click(function () {
    var index = indexPlay;
    index++;
    if (index >= $('.giftinfo').length) {
        index = $('.giftinfo').length - 1;
    }

    clickItem(index);
});

window.addgivenum = function (isadd) {
    var num = $('.give-num').val();
    num = $.trim(num);
    if (num.length == 0) {
        num = 0;
    }

    try {
        num = parseInt(num);
    } catch (e) {
        alert(e.message);
        return;
    }
    if (num < 0) {
        num = 0;
    }

    if (isadd) {
        num = num + 1;
    } else if (num > 1) {
        num = num - 1;
    } else {
        num = 1;
    }

    $('.give-num').val(num);
};

$('.give-add').click(function () {
    addgivenum(true);
});

$('.give-minus').click(function () {
    addgivenum(false);
});


$(document).on('click', '.giftinfo', function (event) {
    var ele = $(this);
    if (init) {
        if (ele.data('index') == indexPlay) {
            return;
        }
    } else {
        init = true;
    }

    indexPlay = ele.data('index');
    indexPlay = parseInt(indexPlay);

    $('.gift-select').removeClass('gift-select');
    $(this).children('.gift-hover').addClass('gift-select');

    move();
});

$('.give-btn').click(function () {
    if (!islogin()) {
        // alert('请先登录');
        showLogin();
        return;
    }

    var giftselect = $('.gift-select');
    if (giftselect.length == 0) {
        alert('请选择礼物');
        return;
    }

    var num = $('.give-num').val();
    num = $.trim(num);
    if (num.length == 0) {
        alert('请选择赠送个数');
        return;
    }

    try {
        num = parseInt(num);
    } catch (e) {
        alert(e.message);
        return;
    }

    if (num <= 0) {
        alert('赠送个数必须大于0');
        return;
    }

    var info = giftselect.parent().data('info');

    var total = (num * info.price);
    if ((account.coins - total) <= 0) {
        alert('余额不足，剩余金额:' + account.coins);
        return;
    }

    // var content = $.trim($('#msgcontent').val());

    var data = {
        'from_ip': info.id,
        'gift_id': info.id,
        'gift_count': num
    };
    $.ajax({
        type: 'post',
        async: true,
        url: ROOT + '/shows/' + showInfo.id + '/room/gift/send-gift',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        headers: {
            'X-DFSX-RoomId': roomInfo.room_id
        },
        success: function (result) {
            // $('#msgcontent').val('');
        },
        error: function (error) {
            console.log(error);
            alert('发送礼物失败, ' + error.responseText);
        }
    });
});

$('.room-panel-publish-btn').click(function () {
    if (!islogin()) {
        // alert('请先登录');
        showLogin();
        return;
    }

    var content = $.trim($('#msgcontent').val());
    if (content.length == 0) {
        // alert('请输入内容');
        return;
    }

    if (roomInfo == null) {
        alert('没有进入直播间');
        return;
    }

    var data = {
        'message': content
    };
    $.ajax({
        type: 'post',
        async: true,
        url: ROOT + '/shows/' + showInfo.id + '/room/chat/messages',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        headers: {
            'X-DFSX-RoomId': roomInfo.room_id
        },
        success: function (result) {
            $('#msgcontent').val('');
        },
        error: function (error) {
            console.log(error);
            alert('发送消息失败, ' + error.responseText);
        }
    });
});

window.connectMQTT = function () {
    client = new Paho.MQTT.Client(roomInfo.web_socket_address + '/mqtt', roomInfo.client_id);

    // set callback handlers
    client.onConnectionLost = onConnectionLost;
    client.onMessageArrived = onMessageArrived;

    // connect the client
    client.connect({
        'userName': '',
        'password': '',
        'mqttVersion': 4,
        'onSuccess': onConnect
    });
};

// called when the client connects
window.onConnect = function () {
    // Once a connection has been made, make a subscription and send a message.
    console.log('onConnect');
    // client.subscribe('/users/' + roomInfo.user_id);
    client.subscribe('/rooms/' + roomInfo.room_id);
    // var message = new Paho.MQTT.Message('Hello');
    // message.destinationName = 'World';
    // client.send(message);
};

// called when the client loses its connection
window.onConnectionLost =
    function (responseObject) {
        if (responseObject.errorCode !== 0) {
            console.log('onConnectionLost:' + responseObject.errorMessage);
        }
    };

// called when a message arrives
window.onMessageArrived = function (message) {
    console.log('onMessageArrived:' + message.payloadString);

    var msg = JSON.parse(message.payloadString);
    showMsg(msg);
};

window.showMsg = function (msg) {
    if (msg.show_id != undefined && msg.show_id != showInfo.id) {
        return;
    }

    switch (msg.type) {
        case 'system_user_entered':
        case 'system_user_exited':
            // updateUserCount(msg.current_user_count);
            break;

        case 'system_quit':
            quitRoom(msg);
            break;

        case 'image_text_message':
            addimagetext(msg);
            break;

        case 'chat_message':
            addchat(msg);
            break;

        case 'system_show_started':
            showStart(msg);
            break;
        case 'system_show_stopped':
            showStop(msg);
            break;

        case 'system_output_stream_started':
            streamStart(msg);
            break;
        case 'system_output_stream_stopped':
            streamStop(msg);
            break;
        case 'gift_send_gift':
            giftSend(msg);
            break;
    }
};

window.giftSend = function (msg) {
    var gift = getgiftinfo(msg.gift_id);
    var str = '<p>' + msg.user_nickname + '送了' + msg.count + '个' + gift.name + '</p>';
    showmsglist(str);
};

window.updateUserCount = function (count) {
    $('.currentusers').text(count + ' 人');
};

window.showStart = function (msg) {
    // showStartLiveBtn(false);
    // updataStateText(2);

    // $('.stoplive').prop('disabled', false);

    streamStartedInfo = msg;
    playCurrentStream();
};

window.showStop = function (msg) {
    // alert('直播结束');
    // showStartLiveBtn(true);
    // updataStateText(3);

    // $('.startlive').prop('disabled', false);
};

window.streamStart = function (msg) {
    // streamStartedInfo = msg;

    // playCurrentStream();
};

window.streamStop = function (msg) {
    stopCurrentStream();

    streamStartedInfo = null;
};

window.updataStateText = function (state) {
    var str = '';
    switch (state) {
        case 1:
            str = '未直播';
            break;
        case 2:
            str = '正在直播';
            break;
        case 3:
            str = '直播已结束';
            break;
    }
    // $('.state').text(str);
};

window.playCurrentStream = function () {
    var url = streamStartedInfo.view_streams[0].flv_address;
    if (!url) {
        url = streamStartedInfo.view_streams[0].m3u8_address;
    }
    if (!url) {
        url = streamStartedInfo.view_streams[0].play_address;
    }

    startPlay(url, 'content');
};

window.stopCurrentStream = function () {
    if (streamStartedInfo) {
        hidePlayer();
    }
};

window.hidePlayer = function () {
};

window.addimagetext = function (msg) {
    // var date = dateFormat((new Date(msg.timestamp * 1000)), 'MM/dd hh:mm:ss');

    showPlayMsg(msg.text);

    var str = '<p>' + msg.text + '</p>';
    showmsglist(str);
};

window.addchat = function (msg) {
    // var date = dateFormat((new Date(msg.timestamp * 1000)), 'MM/dd hh:mm:ss');

    showPlayMsg(msg.body);

    var str = '<p>' + msg.user_nickname + ': ' + msg.body + '</p>';
    showmsglist(str);
};

window.showmsglist = function (str) {
    var eles = $('.room-panel-list-msg').find('p');
    if (eles && eles.length > 100) {
        eles[0].remove();
    }

    $('.room-panel-list-msg').append(str);

    scrollMsglist();
};

window.scrollMsglist = function () {
    $('.room-panel-list-msg').animate({
        scrollTop: $('.room-panel-list-msg'
        ).prop('scrollHeight')
    }, 200);
};

$(window)
    .bind('beforeunload', function (e) {
        return;
    })
    .bind('unload', function () {
        quitRoom();
    });

window.quitRoom = function () {
    if (client) {
        client.unsubscribe('/users/' + roomInfo.user_id);
        client.unsubscribe('/rooms/' + roomInfo.room_id);
        client.disconnect();
    }
};

window.getliveinfo = function () {
    showWait();
    var id = $('.roominfo').data('id');
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/' + id,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            liveinfo = result;

            if (liveinfo.cover_url) {
                $('.toproom-img').children('img').attr('src', liveinfo.cover_url);
            }

            $('.toproom-livename').children('span').text(liveinfo.title);

            if (liveinfo.state == 3) {
                // location.href = ROOT + '/playbacks/' + liveinfo.id;
                // return;

                startwatch();
                enterroom('');
            } else if (liveinfo.state == 1 && liveinfo.forenotice) {
                enterroom('');

                if (typeof liveinfo.forenotice_picture_url != 'undefined' &&
                    liveinfo.forenotice_picture_url &&
                    liveinfo.forenotice_picture_url.length > 0) {
                    $('.live-forenotice-picture').attr('src', liveinfo.forenotice_picture_url);
                    $('.live-forenotice-picture').show();
                } else if (typeof liveinfo.forenotice_video != 'undefined' &&
                    liveinfo.forenotice_video &&
                    liveinfo.forenotice_video.versions &&
                    liveinfo.forenotice_video.versions.length > 0) {
                    $('.live-forenotice-picture').hide();

                    var versions = liveinfo.forenotice_video.versions;

                    var urlmp4 = '';
                    var urlflv = '';
                    var urlm3u8 = '';
                    var urlother = '';
                    for (var i = 0; i < versions.length; i++) {
                        var path = versions[i].url;
                        var ext = getext(path);
                        if (ext === 'mp4') {
                            urlmp4 = path;
                            // 预告视频，使用找到的第一个mp4地址
                            break;
                        } else if (ext === 'flv') {
                            urlflv = path;
                        } else if (ext === 'm3u8') {
                            urlm3u8 = path;
                        } else {
                            urlother = path;
                        }
                    }

                    var url = '';
                    if (urlmp4.length > 0) {
                        url = urlmp4;
                    } else if (urlflv.length > 0) {
                        url = urlflv;
                    } else if (urlm3u8.length > 0) {
                        url = urlm3u8;
                    } else if (urlother.length > 0) {
                        url = urlother;
                    }

                    if (url.length > 0) {
                        startPlay([url], 'content', true);
                    }
                }
            } else {
                $('.onlines').text('观看：' + liveinfo.current_visitor_count);

                if (liveinfo.password) {
                    showpassworddlg();
                } else {
                    enterroom('');
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

window.showlasttime = function (startTime) {
    if (!startTime) {
        return;
    }

    var startdate = new Date(startTime * 1000);
    var currentdata = new Date();

    if (startdate <= currentdata) {
        return;
    }

    var diff = startdate - currentdata;

    var totalseconds = Math.ceil(diff / 1000);

    var hours = Math.ceil(totalseconds / 60 / 60);
    var seconds = Math.ceil(totalseconds / 60 % 60);

    $('#showtime-counts').text(hours + ':' + seconds);
    $('#showtime-seconds').text();
};

window.enterroom = function (password) {
    showWait();
    var id = $('.roominfo').data('id');
    var data = {
        password: password
    };
    $.ajax({
        type: 'post',
        async: true,
        url: ROOT + '/channels/' + id + '/enter-room',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    $('#passworddlg').modal('hide');
                    roomInfo = result;

                    if (roomInfo.view_streams) {
                        streamStartedInfo = roomInfo;

                        if (showInfo.state === 2) {
                            playCurrentStream();
                        }
                    }

                    connectMQTT();

                    getChatMsg();
                } else {
                    alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

window.showpassworddlg = function () {
    $('#room-password').val('');
    $('#passworddlg').modal('show');
};

$('.sure-passworddlg').click(function () {
    var password = $.trim($('#room-password').val());
    if (password.length == 0) {
        return;
    }
    enterroom(password);
});

$('.room-panel-titletab-msg').click(function () {
    $('.room-panel-list').hide();
    $('.room-panel-list-msg').show();
    scrollMsglist();

    $('.room-panel-titletab-select').removeClass('room-panel-titletab-select');
    $(this).addClass('room-panel-titletab-select');
});

$('.room-panel-titletab-bets').click(function () {
    $('.room-panel-list').hide();
    $('.room-panel-list-bets').show();

    $('.room-panel-titletab-select').removeClass('room-panel-titletab-select');
    $(this).addClass('room-panel-titletab-select');

    getQuizshowBets();
});

$('.room-panel-titletab-senders').click(function () {
    $('.room-panel-list').hide();
    $('.room-panel-list-senders').show();

    $('.room-panel-titletab-select').removeClass('room-panel-titletab-select');
    $(this).addClass('room-panel-titletab-select');

    gettopsenders();
});

window.showQuizshowBets = function () {
    if (isQuiz) {
        getQuizshowBets();
    }
};

window.showinfo = null;

window.getQuizshowBets = function () {
    if (!showid) {
        return;
    }

    showWait();

    // $('#betslist').html('');
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/quiz-shows/' + showid,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    showinfo = result;

                    showlasttime(result.start_bet_time);

                    for (var i = 0; i < result.bet_options.length; i++) {
                        var info = result.bet_options[i];

                        var bfind = false;
                        var eles = $('.betitem-info');
                        for (var n = 0; n < eles.length; n++) {
                            var ele = eles.eq(n);
                            var eleInfo = ele.data('info');
                            if (eleInfo.id == info.id) {
                                ele.data('info', eleInfo);
                                ele.find('.betitem-total_amount').text(eleInfo.total_amount);
                                ele.find('.betitem-current_total_amount').text(eleInfo.current_total_amount);

                                bfind = true;
                                break;
                            }
                        }

                        if (!bfind) {
                            var img = '';
                            if (info.icon_url && info.icon_url.length > 0) {
                                img = '<img src="' + info.icon_url + '?w=40&h=40&s=3">';
                            }
                            var tr = '<tr class="betitem-info" style="background: url("/images/betitem-"' + (i % 3) +
                                '".png") no-repeat center center;" data-info=\'' + JSON.stringify(info) + '\'>' +
                                '<td class="betitem-title"><div class="betitem-title-bk"><div class="betitem-img">' +
                                img + '</div><div class="betitem-name">' + info.name + '</div></div></td>' +
                                '<td class="betitem-start"><div class="betitem-start-bk">点击押注</div></td>' +
                                '<td class="betitem-amount"><div class="betitem-amount-bk"><div class="betitem-total_amount">' +
                                info.total_amount + '</div><div class="betitem-line"></div><div class="betitem-current_total_amount">' +
                                info.current_total_amount + '</div></div></td></tr>';
                            $('#betslist').append(tr);
                        }
                    }
                } else {
                    alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};

window.getbetinfo = function (id) {
    if (!showinfo) {
        return null;
    }

    for (var i = 0; i < showinfo.bet_options.length; i++) {
        var info = showinfo.bet_options[i];
        if (info.id == id) {
            return info;
        }
    }

    return null;
};

$(document).on('click', '.betitem-start-bk', function (event) {
    var info = $(this).parent().parent().data('info');

    initbetstartdlg();

    $('#betstart-title').html(info.name);
    $('#betstart-title').data('id', info.id);

    if (account) {
        var my = account.coins;
        $('#betstart-my').text(my);
    }
    $('#betstartdlg').modal('show');
});

window.islogin = function () {
    if ($('.top .top-user').data('info')) {
        return true;
    }

    return false;
};

window.getaccount = function () {
    if (!islogin()) {
        return;
    }

    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/users/account',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    account = result;
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
            setTimeout('getaccount()', 5000);
        }
    });
};

getaccount();

window.initbetstartdlg = function () {
    $('#betstart-title').html('');
    $('#betstart-num').val(5);

    initBetcoins();
    $('.bet-coins-5').addClass('bet-coins-5-select');

    $('#betstart-my').html('');
};

window.initBetcoins = function () {
    $('.bet-coins-5-select').removeClass('bet-coins-5-select');
    $('.bet-coins-10-select').removeClass('bet-coins-10-select');
    $('.bet-coins-20-select').removeClass('bet-coins-20-select');
    $('.bet-coins-50-select').removeClass('bet-coins-50-select');
    $('.bet-coins-all-select').removeClass('bet-coins-all-select');

};

$('.bet-coins-5').click(function () {
    if (!$(this).hasClass('bet-coins-5-select')) {
        initBetcoins();
        $(this).addClass('bet-coins-5-select');
        $('#betstart-num').val(5);
    }
});

$('.bet-coins-10').click(function () {
    if (!$(this).hasClass('bet-coins-10-select')) {
        initBetcoins();
        $(this).addClass('bet-coins-10-select');
        $('#betstart-num').val(10);
    }
});

$('.bet-coins-20').click(function () {
    if (!$(this).hasClass('bet-coins-20-select')) {
        initBetcoins();
        $(this).addClass('bet-coins-20-select');
        $('#betstart-num').val(20);
    }
});

$('.bet-coins-50').click(function () {
    if (!$(this).hasClass('bet-coins-50-select')) {
        initBetcoins();
        $(this).addClass('bet-coins-50-select');
        $('#betstart-num').val(50);
    }
});

$('.bet-coins-all').click(function () {
    if (!$(this).hasClass('bet-coins-all-select')) {
        initBetcoins();
        $(this).addClass('bet-coins-all-select');
        var all = $('#betstart-my').html();
        $('#betstart-num').val(all);
    }
});

$('#sure-betstartdlg').click(function () {
    var id = $('#betstart-title').data('id');
    var num = $('#betstart-num').val();

    var data = {
        'option_chosen': id,
        'bet_coins': num
    };
    $.ajax({
        type: 'post',
        async: true,
        url: ROOT + '/shows/' + showInfo.id + '/room/quiz/bet',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        headers: {
            'X-DFSX-RoomId': roomInfo.room_id
        },
        success: function (result) {
            $('#betstartdlg').modal('hide');
        },
        error: function (error) {
            console.log(error);
            alert('下注失败, ' + error.responseText);
        }
    });
});

window.initBetdetaildlg = function () {
    $('#betdetaildlg-img').html('');
    $('#betdetaildlg-title').html('');
    $('#betdetaildlg-detail').html('');
};

window.showBetdetaildlg = false;

$('body').on('mouseenter', '.betitem-title', function () {
    initBetdetaildlg();

    var info = $(this).parent().data('info');

    var img = '';
    if (info.icon_url && info.icon_url.length > 0) {
        img = '<img src="' + info.icon_url + '"?w=40&h=40&s=3">';
    }

    $('#betdetaildlg-img').html(img);
    $('#betdetaildlg-title').text(info.name);
    $('#betdetaildlg-detail').text(info.detail);

    var x = $(this).offset();
    x.left -= (228 + 8);
    $('#betdetaildlg').css('left', x.left + 'px');
    $('#betdetaildlg').css('top', x.top + 'px');

    showBetdetaildlg = true;

    $('#betdetaildlg').show();
});
$('body').on('mouseleave', '.betitem-title', function () {
    showBetdetaildlg = false;
    setTimeout('hideBetdetaildlg()', 200);
});

window.hideBetdetaildlg = function () {
    if ($('#betdetaildlg').data('show') != 'true' && !showBetdetaildlg) {
        $('#betdetaildlg').hide();
    }
};

$('#betdetaildlg').hover(function () {
    $('#betdetaildlg').data('show', 'true');
    $('#betdetaildlg').show();
}, function () {
    $('#betdetaildlg').hide();
    $('#betdetaildlg').data('show', 'false');
});

showQuizshowBets();
getliveinfo();

function getOnlines() {
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/shows/' + showInfo.id + '/room/onlines',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            $('.onlines').text('观看：' + result.total);
        },
        error: function (error) {
            console.log(error);
        }
    });
}

$(function () {
    $('#msgcontent').bind('keyup', function () {
        var txtChange = $('#msgcontent').val();
        if (txtChange.length == 50) {
            return;
        }
        $('.room-panel-publish-count').text(50 - txtChange.length);
    });

    // getOnlines();
});

window.startwatch = function () {
    showWait();
    var id = $('.roominfo').data('id');
    var type = $('.roominfo').data('type');
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/shows/' + id + '/playback',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    var url = '';
                    if (result.length > 0) {
                        result = result[0].files;

                        for (var i = 0; i < result.length; i++) {
                            var urlmp4 = '';
                            var urlflv = '';
                            var urlm3u8 = '';
                            var urlother = '';

                            $.each(result[i].file_extra_urls, function (i, val) {
                                var path = val;
                                var ext = getext(path);
                                if (ext == 'mp4') {
                                    urlmp4 = path;
                                } else if (ext == 'flv') {
                                    urlflv = path;
                                } else if (ext == 'm3u8') {
                                    urlm3u8 = path;
                                } else {
                                    urlother = path;
                                }
                            });

                            if (urlmp4.length > 0) {
                                url = urlmp4;
                            } else if (urlflv.length > 0) {
                                url = urlflv;
                            } else if (urlm3u8.length > 0) {
                                url = urlm3u8;
                            } else if (urlother.length > 0) {
                                url = urlother;
                            }

                            var ext = getext(result[i].file_url);
                            if (ext == 'm3u8') {
                                url = result[i].file_url;
                            }
                        }
                    }

                    if (url.length > 0) {
                        startPlay([url], 'content');
                    }
                } else {
                    alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();
        }
    });
};


window.getChatMsg = function () {
    var id = $('.roominfo').data('id');

    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/shows/' + id + '/room/chat/messages?max=1000&before=0',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        headers: {
            'X-DFSX-RoomId': roomInfo.room_id
        },
        success: function (result) {
            for (var i = (result.length - 1); i >= 0; i--) {
                var msg = result[i];
                if (msg.type != 'chat_message') {
                    continue;
                }

                var str = '<p>' + msg.user_nickname + ': ' + msg.body + '</p>';
                var eles = $('.room-panel-list-msg').find('p');
                if (eles && eles.length > 100) {
                    eles[0].remove();
                }

                $('.room-panel-list-msg').append(str);
            }

            scrollMsglist();
        },
        error: function (error) {
            console.log(error);
        }
    });
};
